import { CustomRenderers } from '../DocumentRenderer';

export const paragraphRenderer: NonNullable<CustomRenderers['block']>['paragraph'] = props => {
	const { children, textAlign } = props!;

	return <p style={{ textAlign }}>{children}</p>;
};
